import React from "react";
const LandingDateFilter = (props) => {
 let dateRangeList = [{ value: 'Today', label: 'Today' }, { value: 'Yesterday', label: 'Yesterday' }, { value: 'Last 7 days', label: 'Last 7 days' },{ label: 'This Week', value: 'This Week' },{ label: 'Last Week', value: 'Last Week' }, { label: 'This Month', value: 'This Month' },{ label: 'Last Month', value: 'Last Month' }, { label: 'This Year', value: 'This Year' },{ label: 'Last Year', value: 'Last Year' }]
   return (
   <div style={{position:"relative"}}>
     <div className="landing_tab_filter_window">
     {dateRangeList.map((dateRange)=> {
       return <div className="landing_tab_filter_text" data-e2e={dateRange.label} onClick={() => props.changeFilter(dateRange.value)} >
       {dateRange.label}
     </div>
     })}
     </div>
   </div>
   );
 };
 export default LandingDateFilter;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/LandingDateFilter.js
 **/